const readEnvLabel = (key, fallback) => {
  const env =
    typeof process !== "undefined" && process?.env
      ? process.env
      : typeof window !== "undefined"
        ? window.__VITE_ENV__
        : undefined;
  const raw = env?.[key];
  if (typeof raw !== "string") return fallback;
  const trimmed = raw.trim();
  return trimmed.length ? trimmed : fallback;
};

const toLowerValue = (value) => {
  if (!value) return "";
  return value.toLowerCase();
};

const toSingular = (value) => {
  if (!value) return "";
  return value.endsWith("s") ? value.slice(0, -1) : value;
};

export const BRAND_LABELS = {
  destinations: readEnvLabel("VITE_BRAND_DESTINATIONS_LABEL", "Locations"),
  districts: readEnvLabel("VITE_BRAND_DISTRICTS_LABEL", "Districts"),
  stays: readEnvLabel("VITE_BRAND_STAYS_LABEL", "Stay Camps"),
  experiences: readEnvLabel("VITE_BRAND_EXPERIENCES_LABEL", "Experiences"),
  cruise: readEnvLabel("VITE_BRAND_CRUISE_LABEL", "Cruise"),
};

export const BRAND_LABELS_LOWER = {
  destinations: toLowerValue(BRAND_LABELS.destinations),
  districts: toLowerValue(BRAND_LABELS.districts),
  stays: toLowerValue(BRAND_LABELS.stays),
  experiences: toLowerValue(BRAND_LABELS.experiences),
  cruise: toLowerValue(BRAND_LABELS.cruise),
};

export const BRAND_LABELS_SINGULAR = {
  destinations: toSingular(BRAND_LABELS.destinations),
  districts: toSingular(BRAND_LABELS.districts),
  stays: toSingular(BRAND_LABELS.stays),
  experiences: toSingular(BRAND_LABELS.experiences),
  cruise: toSingular(BRAND_LABELS.cruise),
};

export const formatBrandLabel = (labelKey, options = {}) => {
  const label = BRAND_LABELS[labelKey] || "";
  if (!label) return "";
  if (options.lowercase) return toLowerValue(label);
  return label;
};
